import { IBackboneElement } from '../BackboneElement';
import { IIdentifier } from '../Identifier';
import { IPeriod } from '../Period';
import { ICodeableConcept } from '../CodeableConcept';
import { IReference } from '../Reference';
import { IDomainResource } from '../Resource';
import { IQuantity } from '../Quantity';
import { IAnnotation } from '../Annotation';
import { ITiming } from '../Timing';

export type CarePlanType = 'CarePlan';

export const isCarePlan = (
  resource: object | null | undefined,
): resource is ICarePlan =>
  !!resource && (resource as ICarePlan).resourceType === 'CarePlan';

export type CarePlanActivityStatus =
  | 'not-started'
  | 'scheduled'
  | 'in-progress'
  | 'on-hold '
  | 'completed'
  | 'cancelled'
  | 'unknown';

export interface ICarePlanActivityDetailComponent extends IBackboneElement {
  category?: ICodeableConcept;
  definition?: IReference;
  code?: ICodeableConcept;
  reasonCode?: ICodeableConcept;
  reasonReference?: IReference[];
  goal?: IReference;
  status?: CarePlanActivityStatus;
  statusReason?: string;
  prohibited?: boolean;
  scheduledTiming?: ITiming;
  scheduledPeriod?: IPeriod;
  scheduledString?: string;
  location?: IReference;
  performer?: IReference;
  productCodeableConcept?: ICodeableConcept;
  productReference?: IReference;
  dailyAmount?: IQuantity;
  quantity?: IQuantity;
  description?: string;
}

export interface ICarePlanActivityComponent extends IBackboneElement {
  outcomeCodeableConcept?: ICodeableConcept;
  outcomeReference?: IReference[];
  progress?: IAnnotation;
  reference?: IReference;
  detail?: ICarePlanActivityDetailComponent;
}

export type CarePlanIntent = 'proposal' | 'plan' | 'order' | 'option';

export type CarePlanStatus =
  | 'draft'
  | 'active'
  | 'suspended'
  | 'completed'
  | 'entered-in-error'
  | 'cancelled'
  | 'unknown';

export interface ICarePlan extends IDomainResource<CarePlanType> {
  identifier?: IIdentifier[];
  definition?: IReference;
  basedOn?: IReference;
  replaces?: IReference;
  partOf?: IReference;
  status: CarePlanStatus;
  intent: CarePlanIntent;
  category?: ICodeableConcept;
  title?: string;
  description?: string;
  subject: IReference;
  context?: IReference;
  period?: IPeriod;
  author?: IReference;
  careTeam?: IReference;
  addresses?: IReference;
  supportingInfo?: IReference;
  goal?: IReference;
  activity?: ICarePlanActivityComponent[];
  note?: IAnnotation;
}
